export const independant_contractor_agreeement= {
    templateId: 215,
    category: 13,
    templateTitle: 'Independant Contractor Agreement',
    templateDescription: `<p></p>`,
    description: `

  `,

    sides: [
        {
            signature: 'Seller:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Name of business entity",
              },
              {
                type: "input",
                required: true,
                placeholder: "Street and street number",
              },
              {
                type: "input",
                required: true,
                placeholder: "Place",
              },
              {
                type: "input",
                required: true,
                placeholder: "State",
              },
              {
                type: "input",
                placeholder: "Registered court number",
                inSignature: true,
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Represented by",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Function",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Seller)',
            delimiter: `i`
        },
        {
            signature: 'Buyer:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Name of business entity",
              },
              {
                type: "input",
                required: true,
                placeholder: "Street and street number",
              },
              {
                type: "input",
                required: true,
                placeholder: "Place",
              },
              {
                type: "input",
                placeholder: "Registered court number",
                inSignature: true,
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Represented by",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Function",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Buyer),'
        }
    ],

    headline: 'have concluded following',
    title: 'AGREEMENT FOR SALE OF GOODS - FALE PARAGRAFI',
    noArticleNumbers: true,

    articles: [

      
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/215_independant_contractor_agreement.ts